import React, { useEffect, useMemo, useState } from "react";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { useDownloadDocument } from "Api/Melder/Document";

const Record = ({ data: docs = [] }) => {
  const [data, setData] = useState([]);

  const {
    downloadDocument,
    isLoading: downloadLoading,
  } = useDownloadDocument();

  useEffect(() => {
    setData(docs || []);
  }, [docs]);

  const downloadFile = async (id) => {
    try {
      const response = await downloadDocument(id);

      if (response?.data?.file?.download) {
        const linkSource = response.data.file.download;
        const extension = response.data.file.extension || "pdf";
        const fileName = `document.${extension}`;

        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: () => "Document",
        accessorKey: "vLabel",
      },
      {
        header: () => "Uploaddatum",
        accessorKey: "vUpload",
      },
      {
        header: () => "Verloopdatum",
        accessorKey: "vExpired",
      },
      {
        header: () => "Actie",
        accessorKey: "file",
        cell: (value) => (
          <button
            type="button"
            className="anchor-action-link border-0 bg-transparent"
            onClick={() => downloadFile(value.row.original.id)}
            disabled={downloadLoading}
          >
            <div className="font-icon-wrapper download-button-style">
              <i className="pe-7s-download btn-icon-wrapper icon"></i>
            </div>
          </button>
        ),
      },
    ],
    [downloadLoading]
  );

  return (
    <>
      {data.length > 0 ? (
        <ReactTableGeneric
          data={data}
          tableClassName="mb-0 table table-sm table-hover"
          columns={columns}
          filters={{ search: false, pagination: false, sorting: true }}
        />
      ) : (
        <div className="text-center">Geen documenten beschikbaar</div>
      )}
    </>
  );
};
export default Record;
